import SecondFactorAlert from "./SecondFactorAlert";

export default SecondFactorAlert;
